import { ControlProperty, ControlStringProperty, UserBaseModel } from '../../../../../common/models';
import { Validators } from '@angular/forms';
import { EMAIL_PATTERN, Language, Role } from '../../../../../common/constants';

export class OrganizationUserModel extends UserBaseModel {
  constructor(userRoles: Role[], params?: UserBaseModel) {
    super();
    this.roles = userRoles;
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class OrganizationUserForm {
  constructor(
    userModel: OrganizationUserModel,
    public firstName: ControlStringProperty = [userModel.firstName, [Validators.required]],
    public lastName: ControlStringProperty = [userModel.lastName, [Validators.required]],
    public email: ControlStringProperty = [userModel.email, [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
    public country: ControlStringProperty = [userModel.country, [Validators.required]],
    public timezone: ControlStringProperty = [userModel.timezone, [Validators.required]],
    public department: ControlStringProperty = [userModel.department, []],
    public roles: ControlProperty<Role[]> = [userModel.roles as Role[], []],
    public defaultLanguage: ControlProperty<Language> = [userModel.defaultLanguage, []],
  ) {}
}
